require("../resources/css/general/general.min.css");
require("../resources/css/general/basic-setup.min.css");
require("../resources/css/general/calendar.min.css");
require("../resources/css/general/flash-messages.min.css");
require("../resources/css/general/helper.min.css");
require("../resources/css/general/license.min.css");
require("../resources/css/general/login.min.css");
require("../resources/css/general/sorting.min.css");
require("../resources/css/general/welcome.min.css");
require("../resources/css/general/num-keys.min.css");
require("../resources/css/general/add-database.min.css");
require("../resources/css/modals/modal-general.min.css");
require("../resources/css/gamma-style.min.css");
require("../resources/css/gamma-grey-style.min.css");
require("../resources/css/style/style.min.css");
require("../resources/css/style/accordion.min.css");
require("../resources/css/style/calendar.min.css");
require("../resources/css/style/color.min.css");
require("../resources/css/style/colorants.min.css");
require("../resources/css/style/custom-formula.min.css");
require("../resources/css/style/customers.min.css");
require("../resources/css/style/favorites.min.css");
require("../resources/css/style/footer.min.css");
require("../resources/css/style/forms.min.css");
require("../resources/css/style/left-panel.min.css");
require("../resources/css/style/main.min.css");
require("../resources/css/style/matching.min.css");
require("../resources/css/style/navbar.min.css");
require("../resources/css/style/note.min.css");
require("../resources/css/style/notification.min.css");
require("../resources/css/style/price.min.css");
require("../resources/css/style/products.min.css");
require("../resources/css/style/recipe.min.css");
require("../resources/css/style/select-box.min.css");
require("../resources/css/style/server-connection.min.css");
require("../resources/css/style/settings.min.css");
require("../resources/css/style/spectro.min.css");
require("../resources/css/style/statistics.min.css");
require("../resources/css/style/tree-list.min.css");
require("../resources/css/style/coloris.min.css");
require("../resources/css/style/settings/price.min.css");
require("../resources/css/modals/modal-style.min.css");
require("../resources/css/light-style.min.css");
require("../resources/css/modals/modal-light.min.css");
require("../resources/css/keyboard.min.css");
require("../resources/css/tippy.min.css");
require("../resources/css/flags.min.css");
require("../resources/css/rcc.min.css");
require("../resources/css/wizard.min.css");
require("../resources/css/christmas.min.css");
require("../resources/css/all-custom-styles.min.css");
